export enum CardApiUrls {
  Cards = "/v1/Cards",
  CardRename = "/v1/Cards/:cardId/Rename",
  CardStatus = "/v1/Cards/:cardId/Status",
  CardBalance = "/v1/Cards/:cardId/Balance",
  CardTransactions = "/v1/Cards/:cardId/Transactions",
  CardOnlineTransactions = "/v1/Cards/:cardId/OnlineTransactions",
  CardStatement = "/v1/Cards/:cardId/Statements",
  CardStatementExport = "/v1/Cards/:cardId/Statements/Export",
  CardHolder = "/v2/Cards/:cardNumber/Holder",
}


export enum CardNetwork {
  Visa = "Visa",
  MasterCard = "MasterCard",
  ArCa = "Arca",
}

export enum CardClassification {
  Classic = "Classic",
  Platinum = "Platinum",
}

export enum CardStatuses {
  Blocked = "Blocked",
  NotActive = "NotActive",
}

export enum CardStatusesTranslations {
  Blocked = "blocked",
  NotActive = "not_active",
}

export enum CardHistoryTabs {
  Transactions = "transactions",
  OnlineTransactions = "online_transactions",
}

export enum CardApiTagTypes {
  CardList = "CardList",
}
